// Copyright (c) Docugami, Inc. All rights reserved.

import { IMappedTokens } from "./MappedTokens";

export type SpanId = {
    fileId: string,
    fromTokenKey: string,
    toTokenKey: string,
    subtreeId?: string,
    value: string;
}

export class SpanIdUtils {
    static getTokenRange(mappedTokens: IMappedTokens, spanId?: SpanId) {
        if (!!spanId) {
            return mappedTokens.tokenKeyRangeToTokenRange({fromTokenKey: spanId.fromTokenKey, toTokenKey: spanId.toTokenKey})
        }
    }

    static create(fileId: string, fromTokenKey: string, toTokenKey: string, subtreeId?: string) {
        const parts = [fileId, fromTokenKey, toTokenKey];
        if (!!subtreeId) {
            parts.push(subtreeId);
        }

        return {
            fileId: fileId,
            fromTokenKey: fromTokenKey,
            toTokenKey: toTokenKey,
            subtreeId: subtreeId,
            value: parts.join('.')
        }
    }

    static createAddedChunk(fileId: string, definitionId?: string) {
        return SpanIdUtils.create(fileId, "0", "0", definitionId);
    }

    static tryParse(spanIdString?: string | null): SpanId | undefined {
        if (!!spanIdString) {
            const parts = spanIdString.split('.');
            if (parts.length < 3 || parts.length > 4) {
                return;
            }

            const spanId: SpanId = {
                value: spanIdString,
                fileId: parts[0],
                fromTokenKey: parts[1],
                toTokenKey: parts[2]
            }

            if (parts.length === 4) {
                spanId.subtreeId = parts[3];
            }

            return spanId;
        }
    }

    static parse(spanIdString: string): SpanId {
        const spanId = this.tryParse(spanIdString);
        if (!spanId) {
            throw new Error(`Invalid spanId: ${spanIdString}`);
        }

        return spanId;
    }
}
